var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"seminar-info"},[_c('div',{staticClass:"seminar-info__wrap"},[_c('h2',[_vm._v(_vm._s(_vm.seminarInfoContent.title))]),_c('div',{staticClass:"seminar-info__wrap--content",domProps:{"innerHTML":_vm._s(_vm.seminarInfoContent.description)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }